
import { CustomLinkStyle } from "./style"

export const CustomLink = ({ children, to, width }: { children: React.ReactNode, to: string, width?: string }) => {
    return (
        <CustomLinkStyle to={to} width={width}>
            {children}
        </CustomLinkStyle>
    )
}